<div class="flex gap-4 mb-8" [ngClass]="{ 'cursor-not-allowed': isDisabled }">
  <div
    *ngFor="let device of deviceOptions"
    (click)="onSelect(device.value)"
    class="max-w-40 min-w-32 flex flex-col items-center justify-center text-center border rounded cursor-pointer p-2 transition ease-in-out hover:bg-neutral-100"
    [ngClass]="{
        'bg-chathams-blue-100 ring-brand-chathams-blue ring-offset-0 ring-2': selectedValue === device.value,
        'border-gray-300': selectedValue !== device.value,
        'ring-chathams-blue-600': isDisabled,
        'pointer-events-none': isDisabled,
        'opacity-50': isDisabled && selectedValue !== device.value
      }">
    <div class="text-sm font-semibold">{{ device.label | translate }}</div>
    <div class="text-xs opacity-80 whitespace-normal break-words">{{ device.description | translate }}</div>
  </div>
</div>
